import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, DynamicForm, FieldVariant, MultiSelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { getSingleFieldObjectFactory } from '@/components/form-builder/utils/single-field-factory';
import { DacRepository } from '@/store/dac-state/dac-state.repository';

interface getDACCommiteeDialogProps {
  store: DacRepository;
  committees: SelectOption[];
  validate: () => void;
}

export const getDACCommiteeDialog = ({ store, committees, validate }: getDACCommiteeDialogProps): DialogObject => {
  const committeField: DynamicField<MultiSelectFieldProps> = {
    label: 'dac.form.committee',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'dac.form.placeholders.committee',
      options: committees,
      value: store.getObservable('comSelected'),
      onSelectChange: (value: any) => {
        store.set('comSelected', value);
      },
    },
  };
  const formObject: DynamicForm = getSingleFieldObjectFactory(committeField);
  return {
    title: 'dac.form.committee',
    actions: [
      {
        label: 'dac.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
  };
};
